import React from "react";
import logo from "../../assets/images/cross-menu-icon.svg";

const crossMenuLogo = props => <img onClick={props.onClick} src={logo} alt="cross-menu" />;

export default crossMenuLogo;
